module.exports = __webpack_public_path__ + "img/blacksmith_icon.a7dbed38.svg";